/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DirectoryUsersResponse,
  IdentityRuleRecord,
  IdentityRuleRequest,
  SaveUserRequest,
  SearchUsersRequest,
  SessionMeResponse,
  SyncUsersRequest,
  SyncUsersResponse,
  User
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiSessionMeUrl = () => {




  return `/api/session/me`
}

export const getApiSessionMe = async ( options?: RequestInit): Promise<SessionMeResponse> => {

  return orvalControlFetch<SessionMeResponse>(getGetApiSessionMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiSessionMeQueryKey = () => {
    return [
    `/api/session/me`
    ] as const;
    }


export const getGetApiSessionMeQueryOptions = <TData = Awaited<ReturnType<typeof getApiSessionMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSessionMe>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSessionMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSessionMe>>> = ({ signal }) => getApiSessionMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSessionMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSessionMeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSessionMe>>>
export type GetApiSessionMeQueryError = unknown


export function useGetApiSessionMe<TData = Awaited<ReturnType<typeof getApiSessionMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSessionMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSessionMe>>,
          TError,
          Awaited<ReturnType<typeof getApiSessionMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSessionMe<TData = Awaited<ReturnType<typeof getApiSessionMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSessionMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSessionMe>>,
          TError,
          Awaited<ReturnType<typeof getApiSessionMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSessionMe<TData = Awaited<ReturnType<typeof getApiSessionMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSessionMe>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSessionMe<TData = Awaited<ReturnType<typeof getApiSessionMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSessionMe>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSessionMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiIdentityUsersUrl = () => {




  return `/api/identity/users`
}

export const postApiIdentityUsers = async (searchUsersRequest: SearchUsersRequest, options?: RequestInit): Promise<DirectoryUsersResponse> => {

  return orvalControlFetch<DirectoryUsersResponse>(getPostApiIdentityUsersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      searchUsersRequest,)
  }
);}




export const getPostApiIdentityUsersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityUsers>>, TError,{data: SearchUsersRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityUsers>>, TError,{data: SearchUsersRequest}, TContext> => {

const mutationKey = ['postApiIdentityUsers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiIdentityUsers>>, {data: SearchUsersRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiIdentityUsers(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiIdentityUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiIdentityUsers>>>
    export type PostApiIdentityUsersMutationBody = SearchUsersRequest
    export type PostApiIdentityUsersMutationError = unknown

    export const usePostApiIdentityUsers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityUsers>>, TError,{data: SearchUsersRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiIdentityUsers>>,
        TError,
        {data: SearchUsersRequest},
        TContext
      > => {
      return useMutation(getPostApiIdentityUsersMutationOptions(options), queryClient);
    }
    export const getPostApiIdentityUsersSyncUrl = () => {




  return `/api/identity/users/sync`
}

export const postApiIdentityUsersSync = async (syncUsersRequest: SyncUsersRequest, options?: RequestInit): Promise<SyncUsersResponse> => {

  return orvalControlFetch<SyncUsersResponse>(getPostApiIdentityUsersSyncUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      syncUsersRequest,)
  }
);}




export const getPostApiIdentityUsersSyncMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityUsersSync>>, TError,{data: SyncUsersRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityUsersSync>>, TError,{data: SyncUsersRequest}, TContext> => {

const mutationKey = ['postApiIdentityUsersSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiIdentityUsersSync>>, {data: SyncUsersRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiIdentityUsersSync(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiIdentityUsersSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postApiIdentityUsersSync>>>
    export type PostApiIdentityUsersSyncMutationBody = SyncUsersRequest
    export type PostApiIdentityUsersSyncMutationError = unknown

    export const usePostApiIdentityUsersSync = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityUsersSync>>, TError,{data: SyncUsersRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiIdentityUsersSync>>,
        TError,
        {data: SyncUsersRequest},
        TContext
      > => {
      return useMutation(getPostApiIdentityUsersSyncMutationOptions(options), queryClient);
    }
    export const getPostApiIdentityUsersSaveUrl = () => {




  return `/api/identity/users/save`
}

export const postApiIdentityUsersSave = async (saveUserRequest: SaveUserRequest, options?: RequestInit): Promise<User> => {

  return orvalControlFetch<User>(getPostApiIdentityUsersSaveUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveUserRequest,)
  }
);}




export const getPostApiIdentityUsersSaveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityUsersSave>>, TError,{data: SaveUserRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityUsersSave>>, TError,{data: SaveUserRequest}, TContext> => {

const mutationKey = ['postApiIdentityUsersSave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiIdentityUsersSave>>, {data: SaveUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiIdentityUsersSave(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiIdentityUsersSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiIdentityUsersSave>>>
    export type PostApiIdentityUsersSaveMutationBody = SaveUserRequest
    export type PostApiIdentityUsersSaveMutationError = unknown

    export const usePostApiIdentityUsersSave = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityUsersSave>>, TError,{data: SaveUserRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiIdentityUsersSave>>,
        TError,
        {data: SaveUserRequest},
        TContext
      > => {
      return useMutation(getPostApiIdentityUsersSaveMutationOptions(options), queryClient);
    }
    export const getGetApiIdentityRulesUrl = () => {




  return `/api/identity-rules`
}

export const getApiIdentityRules = async ( options?: RequestInit): Promise<IdentityRuleRecord[]> => {

  return orvalControlFetch<IdentityRuleRecord[]>(getGetApiIdentityRulesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiIdentityRulesQueryKey = () => {
    return [
    `/api/identity-rules`
    ] as const;
    }


export const getGetApiIdentityRulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiIdentityRules>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRules>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiIdentityRulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIdentityRules>>> = ({ signal }) => getApiIdentityRules({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiIdentityRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiIdentityRules>>>
export type GetApiIdentityRulesQueryError = unknown


export function useGetApiIdentityRules<TData = Awaited<ReturnType<typeof getApiIdentityRules>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIdentityRules>>,
          TError,
          Awaited<ReturnType<typeof getApiIdentityRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiIdentityRules<TData = Awaited<ReturnType<typeof getApiIdentityRules>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIdentityRules>>,
          TError,
          Awaited<ReturnType<typeof getApiIdentityRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiIdentityRules<TData = Awaited<ReturnType<typeof getApiIdentityRules>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRules>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiIdentityRules<TData = Awaited<ReturnType<typeof getApiIdentityRules>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRules>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiIdentityRulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiIdentityRulesUrl = () => {




  return `/api/identity-rules`
}

export const postApiIdentityRules = async (identityRuleRequest: IdentityRuleRequest, options?: RequestInit): Promise<IdentityRuleRecord> => {

  return orvalControlFetch<IdentityRuleRecord>(getPostApiIdentityRulesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      identityRuleRequest,)
  }
);}




export const getPostApiIdentityRulesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityRules>>, TError,{data: IdentityRuleRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityRules>>, TError,{data: IdentityRuleRequest}, TContext> => {

const mutationKey = ['postApiIdentityRules'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiIdentityRules>>, {data: IdentityRuleRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiIdentityRules(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiIdentityRulesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiIdentityRules>>>
    export type PostApiIdentityRulesMutationBody = IdentityRuleRequest
    export type PostApiIdentityRulesMutationError = unknown

    export const usePostApiIdentityRules = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiIdentityRules>>, TError,{data: IdentityRuleRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiIdentityRules>>,
        TError,
        {data: IdentityRuleRequest},
        TContext
      > => {
      return useMutation(getPostApiIdentityRulesMutationOptions(options), queryClient);
    }
    export const getGetApiIdentityRulesChannelUserIdUrl = (channel: string,
    userId: string,) => {




  return `/api/identity-rules/${channel}/${userId}`
}

export const getApiIdentityRulesChannelUserId = async (channel: string,
    userId: string, options?: RequestInit): Promise<IdentityRuleRecord> => {

  return orvalControlFetch<IdentityRuleRecord>(getGetApiIdentityRulesChannelUserIdUrl(channel,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiIdentityRulesChannelUserIdQueryKey = (channel: string,
    userId: string,) => {
    return [
    `/api/identity-rules/${channel}/${userId}`
    ] as const;
    }


export const getGetApiIdentityRulesChannelUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>, TError = unknown>(channel: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiIdentityRulesChannelUserIdQueryKey(channel,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>> = ({ signal }) => getApiIdentityRulesChannelUserId(channel,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(channel && userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiIdentityRulesChannelUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>>
export type GetApiIdentityRulesChannelUserIdQueryError = unknown


export function useGetApiIdentityRulesChannelUserId<TData = Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>, TError = unknown>(
 channel: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiIdentityRulesChannelUserId<TData = Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>, TError = unknown>(
 channel: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiIdentityRulesChannelUserId<TData = Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>, TError = unknown>(
 channel: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiIdentityRulesChannelUserId<TData = Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>, TError = unknown>(
 channel: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiIdentityRulesChannelUserId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiIdentityRulesChannelUserIdQueryOptions(channel,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDeleteApiIdentityRulesChannelUserIdUrl = (channel: string,
    userId: string,) => {




  return `/api/identity-rules/${channel}/${userId}`
}

export const deleteApiIdentityRulesChannelUserId = async (channel: string,
    userId: string, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getDeleteApiIdentityRulesChannelUserIdUrl(channel,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiIdentityRulesChannelUserIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiIdentityRulesChannelUserId>>, TError,{channel: string;userId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiIdentityRulesChannelUserId>>, TError,{channel: string;userId: string}, TContext> => {

const mutationKey = ['deleteApiIdentityRulesChannelUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiIdentityRulesChannelUserId>>, {channel: string;userId: string}> = (props) => {
          const {channel,userId} = props ?? {};

          return  deleteApiIdentityRulesChannelUserId(channel,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiIdentityRulesChannelUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiIdentityRulesChannelUserId>>>

    export type DeleteApiIdentityRulesChannelUserIdMutationError = unknown

    export const useDeleteApiIdentityRulesChannelUserId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiIdentityRulesChannelUserId>>, TError,{channel: string;userId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiIdentityRulesChannelUserId>>,
        TError,
        {channel: string;userId: string},
        TContext
      > => {
      return useMutation(getDeleteApiIdentityRulesChannelUserIdMutationOptions(options), queryClient);
    }
